import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { depthChartStyle } from './chartConfig';

const ControlsWrap = styled.div`
  position: absolute;
  top: 12px;
  display: flex;
  transform: translate(-50%, 0);
  align-items: center;
`;

const MidPrice = styled.div`
  font-size: 12px;
`;

const PlusMinus = styled.div<{ disabled: boolean }>`
  color: ${({ disabled }) => (disabled ? 'var(--gray3)' : 'var(--white)')};
  padding: 10px 5px;
  font-size: 25px;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  user-select: none;
  &:hover {
    color: ${({ disabled }) =>
      disabled ? 'var(--gray3)' : 'var(--mainLight)'};
  }
`;

const ChangeButton = ({
  onClick,
  disabled,
  children,
  style,
}: {
  onClick: () => void;
  disabled: boolean;
  children: ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <PlusMinus
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </PlusMinus>
  );
};

type Props = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  isMaximum: boolean;
  isMinimum: boolean;
  midPrice?: number;
  midPriceSymbol: string;
};

function ZoomControls({
  onZoomIn,
  onZoomOut,
  isMaximum,
  isMinimum,
  midPrice,
  midPriceSymbol,
}: Props) {
  return (
    <ControlsWrap
      style={{
        left: `calc(50% + ${depthChartStyle.margin.leftHalf}px - ${Math.round(
          depthChartStyle.margin.right / 2
        )}px)`,
      }}
    >
      <ChangeButton
        onClick={onZoomOut}
        disabled={isMinimum}
        style={{
          transform: 'translateY(-2px)',
        }}
      >
        &ndash;
      </ChangeButton>
      <MidPrice style={{ padding: 10 }}>
        {midPrice?.toFixed(8)} {midPriceSymbol}
      </MidPrice>

      <ChangeButton onClick={onZoomIn} disabled={isMaximum}>
        +
      </ChangeButton>
    </ControlsWrap>
  );
}

const MemoizedZoomControls = React.memo(ZoomControls);

export default MemoizedZoomControls;
